import { debounce } from 'lodash';
import * as React from 'react';
import { queueScrollWith } from '../stores/scrollHelpers';

interface ScrollToProps {
    when: boolean
}

export class ScrollTo extends React.Component<ScrollToProps> {
    static scroll = (ref: Element) => queueScrollWith(ref, () => ref.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
    }));

    static debouncedScroll = debounce(ScrollTo.scroll, 500);
    private ref: HTMLHeadingElement;

    shouldComponentUpdate(nextProps: Readonly<ScrollToProps>): boolean {
        return this.props.when !== nextProps.when;
    }

    componentDidUpdate(): void {
        this.check();
    }

    componentDidMount(): void {
        this.check();
    }

    render() {
        const { children } = this.props;
        return (
            <div ref={ref => this.ref = ref}>{children}</div>
        );
    }

    private check() {
        const { when } = this.props;
        if (!when) return;
        ScrollTo.debouncedScroll(this.ref);
    }

}
